import {add} from "@/utils/toastNotification/toast";


export const toastNotification = {
  add
};

